export function getParents(items, id) {
    const { parents } = getParentsInner(items, id, { parents: [], isFound: false });
    return parents;
}
function getParentsInner(items, id, { parents, }) {
    for (const item of items) {
        if (item.id === id) {
            return { parents, isFound: true };
        }
        if (item.children) {
            const res = getParentsInner(item.children, id, { parents: [...parents, item], isFound: false });
            if (res && res.isFound) {
                return { parents: res.parents, isFound: true };
            }
        }
    }
    return { parents: [], isFound: false };
}
export function setProperty(items, id, property, setter) {
    for (const item of items) {
        if (item.id === id) {
            item[property] = setter(item[property]);
            continue;
        }
        if (item.children?.length) {
            item.children = setProperty(item.children, id, property, setter);
        }
    }
    return [...items];
}
export function updateItem(items, updated) {
    const res = [];
    for (const item of items) {
        if (item.id === updated.id) {
            res.push(updated);
        }
        else {
            if (item.children?.length) {
                item.children = updateItem(item.children, updated);
            }
            res.push(item);
        }
    }
    return res;
}
export function removeItem(items, id) {
    const newItems = [];
    for (const item of items) {
        if (item.id === id) {
            continue;
        }
        if (item.children) {
            item.children = removeItem(item.children, id);
        }
        newItems.push(item);
    }
    return newItems;
}
export function findItemDeep(items, id) {
    for (const item of items) {
        if (item.id === id) {
            return item;
        }
        if (item.children) {
            const child = findItemDeep(item.children, id);
            if (child) {
                return child;
            }
        }
    }
    return undefined;
}
export function getParentId(depth, previousItem, newItems, overItemIndex) {
    if (depth === 0 || !previousItem) {
        return null;
    }
    if (depth === previousItem.depth) {
        return previousItem.parentId;
    }
    if (depth > previousItem.depth) {
        return previousItem.id;
    }
    const newParent = newItems
        .slice(0, overItemIndex)
        .reverse()
        .find((item) => item.depth === depth)?.parentId;
    return newParent ?? null;
}
